import { Box, makeStyles } from '@material-ui/core';
import { SETVIImage, SHighlightText } from '@setvi/shared/components';
import { ColumnsType } from '@setvi/shared/types';
import { useMemo } from 'react';
import { TextColor } from '@setvi/shared/enums';
import { Product as ProductDTO } from '@setvi/shared/interfaces';
import { EmptyCell } from 'pages/sales/modules/orders/components/empty-cell';

const useStyles = makeStyles(theme => ({
  tableImage: {
    height: 68,
    width: 68,
    minWidth: 52,
    borderRadius: 6,
    backgroundSize: 'contain',
    border: `1px solid ${theme.palette.grey[200]}`
  }
}));

interface UseProductColumnsProps {
  searchQuery: string;
}

export const useSearchColumns = ({ searchQuery }: UseProductColumnsProps) => {
  const classes = useStyles();

  const columns: ColumnsType = useMemo(
    () => [
      {
        id: 'product',
        width: '100%',
        label: '',
        cellContent: (row: ProductDTO) => {
          const { name, sku, images } = row;

          return (
            <Box display="flex" alignItems="center">
              <SETVIImage
                className={classes.tableImage}
                src={images[0]?.path || '/images/product-placeholder.svg'}
                alt={name}
              />
              <Box ml={2} display="flex" flexDirection="column" gridGap={4}>
                <Box display="flex" alignItems="center">
                  {name ? (
                    <SHighlightText searchQuery={searchQuery} value={name} />
                  ) : (
                    <EmptyCell />
                  )}
                </Box>
                <Box display="flex" alignItems="center">
                  {sku ? (
                    <SHighlightText
                      weight="normal"
                      size="sm"
                      fontColor={TextColor.LightGrey}
                      searchQuery={searchQuery}
                      value={`SKU: ${sku}`}
                    />
                  ) : (
                    <EmptyCell />
                  )}
                </Box>
              </Box>
            </Box>
          );
        }
      }
    ],
    [classes.tableImage, searchQuery]
  );

  return { columns };
};
